import React, { FunctionComponent } from 'react';

import { css } from '@emotion/react';

import { palette } from '@styles/theme';

interface SortingCellProps {
  flag: boolean;
  order: any;
}

const SortingCell: FunctionComponent<SortingCellProps> = ({ flag, order }) => {
  return (
    <span css={sortContainer}>
      {flag ? (
        <SortArrowIcon toggle={order !== 'desc'} color={palette.primaryColor} />
      ) : (
        <>
          <SortArrowIcon />
          <SortArrowIcon toggle={false} />
        </>
      )}
    </span>
  );
};

interface SortArrowIconProps {
  toggle?: boolean;
  color?: string;
}

const SortArrowIcon: FunctionComponent<SortArrowIconProps> = ({
  toggle = true,
  color,
}) => {
  return (
    <div css={container(toggle, color)}>
      <svg
        width="10"
        height="6"
        viewBox="0 0 10 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 0L9.33013 6H0.669873L5 0Z" fill="#BDBDBD" />
      </svg>
    </div>
  );
};

const sortContainer = css`
  display: flex;
  flex-direction: column;
  div {
    border: none;
  }
`;

const container = (toggle: boolean, color?: string) => css`
  display: flex;
  border: none !important;
  svg {
    transform: rotate(${toggle ? '0deg' : '180deg'});
    height: 10px;
    transition: 0.2s;
    path {
      ${color &&
      css`
        fill: ${color};
      `}
    }
  }
`;

export default SortingCell;
